import httpClient from '@/http-client'

export const classAttendance = data => {
  return httpClient
    .get('/api/report/class-attendance-check-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  classAttendance,
}
